<ul *ngIf="moreArticles?.length > 0" class="list-unstyled">
  <h4 class="title">Artigos Relacionados</h4>
  <li *ngFor="let relacionado of moreArticles.slice(0, 10)" class="item">
    <a
      class="link"
      tabindex="0"
      (click)="redirectArticle(relacionado.resumo, relacionado.categoria)"
      (keydown.enter)="
        redirectArticle(relacionado.resumo, relacionado.categoria)
      "
      (keydown.space)="
        redirectArticle(relacionado.resumo, relacionado.categoria)
      "
    >
      {{ relacionado.titulo }}
    </a>
  </li>
</ul>
